import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDoubleCheckmark1Small"><Path d="M5.5 13.125L8.875 16.5L14.5 7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.875 16.5L18.5 7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDoubleCheckmark1Small;
